module.exports = __webpack_public_path__ + "static/media/toasted-cheesy-goodness.445533e4.mov";


//////////////////
// WEBPACK FOOTER
// ./src/images/2020-06-06/toasted-cheesy-goodness.mov
// module id = 832
// module chunks = 0